module.exports = __webpack_public_path__ + "img/kast.df796554.jpg";